import { find, includes } from "lodash";
// Site config
import {getEnvironmentName} from "../../../../utils"
const environment = getEnvironmentName()
const config = require("../../../../app_configuration").CONFIGURATION[environment];

const data = { role: [], rights: {} };
const defaultAuthorization = [
  {
    rights: ["purchase_license", "license_manager", "owner"],
    roles: ["Administrator"]
  }
];
const moduleName = "subscriptions";

const validate = right => {
  const authorization =
    config.AUTHORIZATIONS && config.AUTHORIZATIONS[moduleName]
      ? config.AUTHORIZATIONS[moduleName]
      : defaultAuthorization;
  return find(authorization, item => {
    return (
      includes(item.rights, right) &&
      find(item.roles, itemRole => {
        return includes(data.role, itemRole);
      })
    );
  });
};
const func = {
  SetRoles: rolesString => {
    data.role = [];
    data.rights = [];
    const rolesArr = rolesString.split(",");
    rolesArr.forEach(element => {
      data.role.push(element.trim());
    });
  },
  Check: right => {
    if (data.rights[right]) return data.rights[right];
    data.rights[right] = validate(right) !== undefined;
    return data.rights[right];
  }
};
export default func;
